import styled from 'styled-components';

const ErrorDiv = styled.div`
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}`;


const CustomError = ({ error }) => {
    return (
        <ErrorDiv>
            {error}
        </ErrorDiv>
    );
};

export default CustomError;